import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { C, lcarsRuleSx } from '../theme/tokens';

/** A single hairline divider between two registers stacked in one panel
 * (identity above, readouts below). Not a per-row separator — a page ruled
 * every 40px is a ladder, not an instrument. */
const LcarsRule: React.FC<{ accent?: string; sx?: SxProps<Theme> }> = ({ accent = C.blue, sx }) => (
  <Box aria-hidden sx={{ ...lcarsRuleSx(accent), ...sx }} />
);

export default LcarsRule;
